import { useSelector } from 'react-redux'
import { uiFlagsSelector } from '@src/selectors/uiFlags'

export const useShowLabResultAnalysisCompletePopup = () => {
  const uiFlags = useSelector(uiFlagsSelector)
  return {
    analysisSuccess: uiFlags.showLabResultAnalysisCompleteBanner,
    analysisFailed: uiFlags.showLabResultAnalysisFailedBanner,
  }
}
